// extracted by css-extract-rspack-plugin
export default {"cls1":"TranslationModal-cls1_4Ws","cls2":"TranslationModal-cls2_kJB TranslationModal-cls1_4Ws"};